export * from './types';
export * from './talon.reducer';

import talonReducer from './talon.reducer';
export default talonReducer;
